import { Badge } from './Badge';
import { statusDescriptor, type StatusKind } from './statusLabels';

/**
 * Etiqueta de estado.
 *
 * A traducao vive em `statusLabels`, e nao aqui, para que o mesmo rotulo sirva a
 * textos fora da etiqueta. Sem isso, a mesma etapa apareceria com nomes diferentes
 * conforme o lugar da tela.
 */
export function StatusBadge({ kind, value }: { kind: StatusKind; value: string }) {
  const descriptor = statusDescriptor(kind, value);
  if (!descriptor) {
    return <Badge tone="neutral">{value}</Badge>;
  }
  return <Badge tone={descriptor.tone}>{descriptor.label}</Badge>;
}
